module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/earrings/hoop-37e4a0f65b3e57b8375c2075a9dd663e.webp";